export default "__VITE_ASSET__BEx3didB__"